import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { UtilService } from '@app/shared/services/util.service';
import { Actions, TableColumn } from '@app/shared/table/TableColumn';
import { apiClientService } from '../api-client/api-client.service';

@Component({
    imports: [FormsModule, SharedModule, RouterModule],
    selector: 'app-api-integration-list',
    templateUrl: './api-integration-list.component.html'
})
export class ApiIntegrationListComponent implements OnInit {

  apiIntegrationData: any = [];
  isLoading = true;

  tableColumns: Array<TableColumn> = [

    {
      name: 'S.No',
      dataKey: 'sno',
      type: 'sequence'
    },

    {
      name: 'Request Method',
      dataKey: 'method',
      type: 'text'
    },

    {
      name: 'Endpoint URL',
      dataKey: 'url',
      type: 'text'
    },

    {
      name: 'Headers',
      dataKey: 'headers_tags',
      type: 'tags'
    },

    {
      name: 'Query Params',
      dataKey: 'query_params_tags',
      type: 'tags'
    },
    {
        name: 'Created Date',
        dataKey: 'created_date_display',
        type: 'text',
        isDefault: false

        
      },
      {
        name: 'Modified Date',
        dataKey: 'modified_date_display',
        type: 'text',
        isDefault: false

      },
      {
        name: 'Body',
        dataKey: 'body',
        type: 'text',
        isDefault: false

      },
      {
        name: 'Body Type',
        dataKey: 'body_type',
        type: 'text',
        isDefault: false

      },

    {
  name: 'Status',
  dataKey: 'is_active',
  type: 'toogle',
  conditionalNaming: {
    true: {
      name: 'Active',
      checked: true,
      disabled: false
    },
    false: {
      name: 'Inactive',
      checked: false,
      disabled: false
    }
  }
},

    {
      name: 'Actions',
      type: 'threeDotActions',
      rowActions: [
        {
          iconName: 'edit',
          name: 'edit',
          iconTooltip: 'Edit'
        },
         {
      iconName: 'history',
      name: 'revisionHistory',
      iconTooltip: 'Revision History'
    },

        {
          iconName: 'trash',
          name: 'delete',
          iconTooltip: 'Delete'
        }
      ]
    }

  ];

  tableActions: Array<Actions> = [
    {
      iconName: 'plus',
      name: 'add',
      iconTooltip: 'Add Integration'
    }
  ];

   dateRangeDetails = {
    isSingle: true,
    startDataKey: 'created_date',
  }; 
filterAttributes = [

  {
    dataKeyName: 'created_date',
    name: 'Added On',
    type: 'date',
    data: [],
  },

  {
    dataKeyName: 'is_active',
    name: 'Status',
    type: 'status',
    data: ['Active', 'Inactive'],
  },

  {
    dataKeyName: 'method',
    name: 'Request Method',
    type: 'text',
    data: [],
  },

  {
    dataKeyName: 'url',
    name: 'Endpoint URL',
    type: 'text',
    data: [],
  },

  {
    dataKeyName: 'all',
    name: 'All Text',
    type: 'all',
    data: [],
  }

];

  constructor(
    private apiClientService: apiClientService,
    private router: Router,
    private util: UtilService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {

    this.isLoading = true;

    this.apiClientService.getAllIntegrations().subscribe({

      next: (res: any) => {

        const data = res.body?.responseBody || [];

        // convert headers & query params to tags
        this.apiIntegrationData = data.map((row: any) => {
          const createdDate = row.created_date ? new Date(row.created_date) : null;
          const modifiedDate = row.modified_date ? new Date(row.modified_date) : null;

          return {

            ...row,
            is_active: !!row.is_active,
            headers_tags: this.convertToTags(row.headers),
            query_params_tags: this.convertToTags(row.query_params),
          
            body_type: row.method === 'GET'
              ? ''
              : (row.body_type || ''),
           
            body: row.method === 'GET'
          ? ''
          : (row.body && Object.keys(row.body).length
              ? JSON.stringify(row.body, null, 2)
              : ''),
          created_date: createdDate,
          modified_date: modifiedDate,

          // UI display
          created_date_display: createdDate
            ? createdDate.toLocaleString('en-GB')
            : '',

          modified_date_display: modifiedDate
            ? modifiedDate.toLocaleString('en-GB')
            : ''
        };   

        });

        this.isLoading = false;
        this.cd.detectChanges();

      },

      error: (err) => {

        console.error(err);
        this.util.errorNotification(err);
        this.isLoading = false;

      }

    });

  }

  convertToTags(obj: any): string[] {

    if (!obj) return [];

    try {

      if (typeof obj === 'string') {
        obj = JSON.parse(obj);
      }

      return Object.entries(obj).map(
        ([key, value]) => `${key}: ${value}`
      );

    } catch {

      return [];

    }

  }

  tableAction(event: string): void {

    if (event === 'add') {

      localStorage.removeItem('integrationId');

      this.router.navigate(['/api-integration/add']);

    }

  }

 rowAction(event: any): void {


  // EDIT
  if (event.rowName === 'edit') {

    localStorage.setItem('integrationId', event.row.id);

this.router.navigate(['/api-integration/edit', event.row.id]);
  }

  // REVISION HISTORY 
  else if (event.rowName === 'revisionHistory') {


    this.router.navigate([
      '/api-integration/revision-history',
      event.row.id,
      event.row.name
    ]);

  }

  // DELETE
  else if (event.rowName === 'delete') {

    this.deleteIntegration(event.row.id);

  }

}

  deleteIntegration(id: number): void {

    this.apiClientService.deleteIntegration(id)
      .subscribe({

        next: () => {

        this.apiIntegrationData = this.apiIntegrationData.filter(
          (row: any) => Number(row.id) !== Number(id)
        );

        this.apiIntegrationData = [...this.apiIntegrationData];

        this.cd.detectChanges();

        },

        error: (err) => {

          console.error(err);

          this.util.errorNotification(err);

        }

      });

  }
updateStatus(event: any) {
  this.apiClientService
    .updateIntegrationStatus(event.id, event.checked)
    .subscribe({
      next: (res) => {
        this.loadData();
      },
      error: (err) => {
          this.util.errorNotification(err);
      }
    });
}
}
